// extracted by mini-css-extract-plugin
export default {"watermarkUploadModal":"watermark-upload-modal_watermarkUploadModal__NsmvY","uploadZone":"watermark-upload-modal_uploadZone__z7th2"};